import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {Play} from "utruckin-icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'videoMessage',
  props: {
    documentUrl: {}
  },
  setup(__props: any) {

const props = __props

const handleClick = (event: MouseEvent): void => {
  event.stopPropagation()
  window.open(props.documentUrl, "_blank");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "f-ui-video",
    onClick: _cache[0] || (_cache[0] = (e) => {handleClick(e)})
  }, [
    _createVNode(_unref(Play), { size: 16 })
  ]))
}
}

})